const initial = {
  logindata: sessionStorage.getItem("userData") || {},
};
export function authReducer(state = initial, { type, payload }) {
  switch (type) {
    case "Login": {
      localStorage.setItem(
        "userData",
        JSON.stringify(payload?.login?.userDetails)
      );
      return {
        ...state,
        logindata: payload?.login,
      };
    }
    default: {
      return state;
    }
  }
}
